import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

/**
 * A simple reusable component to display a loading indicator with an optional customizable message.
 */
@Component({
  selector: "app-loading",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./loading.component.html",
  styleUrl: "./loading.component.scss",
})
export class LoadingComponent {
  @Input()
  text: string = "";
}
